import React, { useMemo } from 'react';
import { Modal, Form } from 'antd';
import {
  useResponseTemplateState,
  useResponseTemplateSetState,
} from '../../model';
import Field, { fieldTypes } from '../../../../../shared/ui/Field';
import { useAddResponseTemplate } from '../../../add';
import { prepareFormValues } from '../../lib';
import { useResponseTemplateChange } from '../../../edit';

const ModalContainer = ({ form }) => {
  const { visible, init } = useResponseTemplateState({});
  const { close } = useResponseTemplateSetState();

  const { add, loading: addLoading } = useAddResponseTemplate();
  const { change, loading: changeLoading } = useResponseTemplateChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const values = prepareFormValues(formValues);
        Boolean(init)
          ? await change({ templateId: init.id, data: values })
          : await add({ data: values });
        close();
      }
    });
  };

  return (
    <Modal
      visible={visible}
      onCancel={close}
      onOk={handleSubmit}
      title={`${Boolean(init) ? 'Изменить' : 'Добавить'} шаблон`}
      destroyOnClose
      confirmLoading={addLoading || changeLoading}
      zIndex={1500}
    >
      <Form colon={false}>
        <Field
          fieldType={fieldTypes.input}
          form={form}
          name="name"
          label="Наименование"
          decoratorOptions={{
            initialValue: init?.name || '',
            rules: [
              {
                required: true,
                message: 'Укажите наименование',
                whitespace: true,
              },
            ],
          }}
        />
        <Field
          fieldType={fieldTypes.textArea}
          form={form}
          name="value"
          label="Текст автоответа"
          decoratorOptions={{
            initialValue: init?.text?.trim()?.replace(/\\n/g, '\n') || '',
            rules: [
              {
                required: true,
                message: 'Укажите текст автоответа',
                whitespace: true,
              },
            ],
          }}
        />
      </Form>
    </Modal>
  );
};

const ResponseTemplateModal = Form.create({
  name: 'add_change_response_template',
})(ModalContainer);

export default ResponseTemplateModal;
